<p-dialog header="Train Model" [(visible)]="display" [style]="{width: '95vw'}" [modal]="true" (onHide)="close()">
    <div class="card" *ngIf="pageIndex == 1">
        <div class="p-grid">
            <div class="p-col-6">
                <p-card [style]="{'width': '100%'}" styleClass="hover-box" (click)="showPredict()">
                    <div class="p-d-flex">
                        <span class="fa fa-eercast predict-icon"></span>
                        <div class="p-ml-3">
                            <h5 class="p-mb-0">Predict</h5>
                            <p>Predict categories and numerical outcomes</p>
                        </div>
                    </div>
                </p-card>
            </div>
            <div class="p-col-6">
                <p-card [style]="{'width': '100%'}" styleClass="hover-box" (click)="showForecast()">
                    <div class="p-d-flex">
                        <span class="fa fa-line-chart" style="color: var(--primary-color);font-size: 20px;"></span>
                        <div class="p-ml-3">
                            <h5 class="p-mb-0">Forecast</h5>
                            <p>Forecast or create a time dependent model</p>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </div>
    <div class="p-grid" *ngIf="pageIndex == 2">
        <div class="p-col-3">
            <div class="card">
                <div class="p-d-flex hoverable" (click)="pageIndex=1">
                    <span class="pi pi-arrow-left p-mr-1"></span>
                    Back to Training Types
                </div>
                <ng-container *ngIf="selectedLabel === 'predict'">
                    <h5 class="p-my-3">Predict</h5>
                    <h6 class="p-mb-0">Predict Fields</h6>
                    <p class="small" style="color: #888;">Select wich numerical or categorical fields to predict and
                        optionally ignore.</p>
                    <ng-container *ngIf="!selectedWorkbookColumn">
                        <p-listbox [options]="columns" [(ngModel)]="selectedPredict" optionLabel="header" [style]="{'width':'100%'}"
                        [filter]="true" (onChange)="changePredict()" *ngIf="selectedLabel == 'predict'"></p-listbox>                        
                     </ng-container>
                     <ng-container *ngIf="selectedWorkbookColumn">
                        <p-listbox [options]="selectedWorkbookColumn" [(ngModel)]="selectedPredict" optionLabel="name" [style]="{'width':'100%'}"
                        [filter]="true" (onChange)="changePredict()" *ngIf="selectedLabel == 'predict'"></p-listbox>                        
                     </ng-container>   
                </ng-container>
                <ng-container *ngIf="selectedLabel === 'forecast'">
                    <ng-container *ngIf="!selectedWorkbookColumn">
                        <h5 class="p-my-3">Time Series</h5>
                        <h6 class="p-mb-0">Date Fields</h6>
                        <p class="small" style="color: #888;">Choose which field corresponds to date in your dataset.</p>
                        <p-listbox [options]="dateColumns" [(ngModel)]="selectedDate" optionLabel="header" [style]="{'width':'100%'}"
                            [filter]="true" (onChange)="changePredict()" *ngIf="selectedLabel == 'forecast'"></p-listbox>
                        <h6 class="p-mb-0" style="padding-top: 15px;">Forecast Fields</h6>
                        <p class="small" style="color: #888;">Select numerical column to perform time series forecasting.</p>
                        <p-listbox [options]="nonDateColumns" [(ngModel)]="selectedPredict" optionLabel="header" [style]="{'width':'100%'}"
                            [filter]="true" (onChange)="changePredict()" *ngIf="selectedLabel == 'forecast'"></p-listbox>
                    </ng-container>
                    <ng-container *ngIf="selectedWorkbookColumn">
                        <h5 class="p-my-3">Time Series</h5>
                        <h6 class="p-mb-0">Date Fields</h6>
                        <p class="small" style="color: #888;">Choose which field corresponds to date in your dataset.</p>
                        <p-listbox [options]="selectedWorkbookDateColumn" [(ngModel)]="selectedDate" optionLabel="name" [style]="{'width':'100%'}"
                            [filter]="true" (onChange)="changePredict()" *ngIf="selectedLabel == 'forecast'"></p-listbox>
                        <h6 class="p-mb-0" style="padding-top: 15px;">Forecast Fields</h6>
                        <p class="small" style="color: #888;">Select numerical column to perform time series forecasting.</p>
                        <p-listbox [options]="selectedWorkbookNonDateColumn" [(ngModel)]="selectedPredict" optionLabel="name" [style]="{'width':'100%'}"
                            [filter]="true" (onChange)="changePredict()" *ngIf="selectedLabel == 'forecast'"></p-listbox>
                    </ng-container>
                </ng-container>
            </div>
        </div>


        <div class="p-col-9">
            <div *ngIf="!showPredictionBtn" class="card alignmentBtn">
                <div class="model-training-container">
                    <div class="button-container">
                      <button *ngIf="selectedLabel === 'predict'" [disabled]="btnDisable" class="flow-interface-action-button" pButton [loading]="btnDisable" (click)="trainModel()">
                        Create Predictive Model
                      </button>
                      <button *ngIf="selectedLabel === 'forecast'" [disabled]="btnDisable" class="flow-interface-action-button" pButton [loading]="btnDisable" (click)="forecastModel()">
                        Create Forecast Model
                      </button>
                    </div>
                  
                    <div *ngIf="btnDisable" class="loading-container">
                      <div class="spinner-wrapper" *ngIf="isLoading">
                        <p-progressSpinner styleClass="custom-spinner" [diameter]="32" [strokeWidth]="3" [fill]="'var(--surface-ground)'" [animationDuration]="'.7s'"></p-progressSpinner>
                        <span class="loading-text">Training model, please wait...</span>
                      </div>
                      <div class="message-container" *ngIf="!isLoading">
                        <i class="pi pi-info-circle info-icon"></i>
                        <p class="message-text">This model training may take a few minutes to train,<br>
                            come back later...</p>
                      </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showPredictionBtn" class="card">
                <p-card *ngIf="forecastingType !== 'Forecasting'">
                    <div class="p-d-flex">
                        <div class="border-right p-pl-3 p-pr-5">
                            <p class="p-mb-0" style="color: #888;">Prediction Column</p>
                            <h5 class="p-mb-0" style="position: relative;">
                                {{ selectedPredict?.header || selectedPredict?.name || 'No prediction column available' }}
                            </h5>
                        </div>
                        <div *ngIf="this.predictionType == 'Classification'" class="p-px-5 toggle"
                            (click)="op.toggle($event)">
                            <p class="p-mb-0" style="color: #888;" *ngIf="predictionType !== 'Regression'">Outcome of
                                Interest</p>
                            <h5 class="p-mb-0">{{selectedCategory.name}}
                                <span class="btnBars">
                                    <i class="pi pi-pencil"></i>
                                </span>
                            </h5>
                        </div>
                        <div class="deck1" style="margin-left: auto;"><button class="btn1"
                                (click)="changePredict()">Re-Train Model</button></div>
                    </div>
                </p-card>
                <p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '250px'}" styleClass="no-padding">
                    <ng-template pTemplate>
                        <p-listbox [options]="categoryList" [(ngModel)]="selectedCategory" optionLabel="name"
                            [style]="{'width':'250px'}" (onChange)="onSelectedCategory($event)"></p-listbox>
                    </ng-template>
                </p-overlayPanel>
                <div class="head2">
                    <h5 class="head1" style="margin-top: 10px;">{{predictionResult.title}}</h5>
                    <p class="head1" style="color: #888;">{{predictionResult.description}}</p>
                </div>
                <div *ngIf="predictionType == 'Classification'" class="p-grid">
                    <div class="p-col-6" [class.p-pb-0]="isShowDetails">
                        <p-card [style]="{'width': '100%'}" [styleClass]="isShowDetails ? 'extend' : 'fixed-height'">
                            <p class="p-mb-0" style="color: #888;">Overall Accuracy</p>
                            <h3 class="p-my-3">{{predictionResult.overallAccuracy}}%</h3>
                            <p>{{predictionResult.match}}</p>
                            <div class="p-d-flex hoverable" 
                                style="color: hsl(218, 80.3%, 47.8%);"
                                (click)="isShowDetails = !isShowDetails">
                                <span [class.pi-angle-right]="!isShowDetails" 
                                      [class.pi-angle-down]="isShowDetails" 
                                      class="pi p-mr-1"></span>
                                {{ isShowDetails ? 'Hide accuracy details' : 'See accuracy details' }}
                           </div>
                        </p-card>
                    </div>


                    <div class="p-col-6 plot-card">
                        <p-card [style]="{'width': '100%'}" styleClass="no-padding fixed-height">
                            <plotly-plot [data]="data8" [layout]="layout8" [style]="{'overflow-y':'scroll'}"></plotly-plot>
                            <div class="prediction-performance">
                                <p class="performance-header p-mb-0">{{predictionPerformanceBlock.header}}</p>
                                <h5 class="performance-highlights" pTooltip="The model's precision for Director is 20.4%, which is good compared to the baseline of 20.3%."
                                    tooltipPosition="top">
                                    <span class="dash-bottom">{{predictionPerformanceBlock.highlights}}</span>
                                </h5>
                            </div>
                            <div class="data-badge yellow right-cornor">{{predictionPerformanceBlock.grade}}</div>
                        </p-card>
                    </div>
                    <div class="p-col-12 p-pt-0" *ngIf="isShowDetails">
                        <p-card [style]="{'width': '100%'}" styleClass="no-top-radius">
                            <p>{{predictionEstimation?.description}}</p>
                            <h5>{{predictionEstimation?.header}}</h5>
                            <ng-container *ngFor="let performance of predictionEstimation?.predictivePerformance">
                                <div class="p-grid"
                                    [ngClass]="{'border-bottom' : performance?.name == 'True Negatives' }">
                                    <div class="p-col-6">
                                        <label>{{performance.name}}</label>
                                        <div class="p-d-flex p-jc-between">
                                            <div class="p-d-flex w-100">
                                                <div class="fix1">
                                                    <p-progressBar [value]="performance?.value[0]" [showValue]="false">
                                                        <ng-template pTemplate="content" let-value>
                                                            <span>{{value}}/{{performance?.value[1]}}</span>
                                                        </ng-template>
                                                    </p-progressBar>
                                                </div>
                                                <div class="p-ml-2">{{performance?.value[0]}}/{{performance?.value[1]}}
                                                </div>
                                            </div>
                                            <div class="true-class">{{performance?.percentage}}%</div>
                                        </div>
                                    </div>
                                    <div class="p-col-6">
                                        <p class="p-mt-4">{{performance.matrix}}</p>
                                    </div>
                                </div>
                            </ng-container>

                        </p-card>
                    </div>
                    <div class="top-feilds">
                        <div class="head2">
                            <h5 class="head1">Top Fields</h5>
                            <p class="head1">Fields ranked by their contribution to the prediction results</p>
                        </div>
                        <div class="p-grid">
                            <div class="p-col-6 p-pr-0">
                                <ul class="field-menu">
                                    <li class="p-d-flex" *ngFor="let s of impact;let i=index"
                                        (click)="onSelctedImpact(s)" [class.isActive]="s?.name == selectedImpact?.name">
                                        <div class="p-text-right" style="width: 45%;"><span pTooltip="{{s.description}}"
                                                tooltipPosition="top">{{s?.name}}</span></div>
                                        <div class="p-d-flex w-100">
                                            <div pTooltip="{{s?.description}}" tooltipPosition="top"
                                            [className]="'block-bg-' + i" [attr.data-value]="s?.value">
                                            </div>
                                            <span pTooltip="{{s?.description}}"
                                                tooltipPosition="top">{{s?.value}}%</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="p-col-6 p-pl-0">
                                <div class="field-table">
                                    <div class="p-grid field-header">
                                        <div class="p-col-6" style="text-align: center;">
                                            When <strong>{{selectedImpact?.name}}</strong> is
                                        </div>
                                        <div class="p-col-6 field-header-right">
                                            Impact on {{selectedPredict?.header}}
                                        </div>
                                    </div>
                                    <p-table [value]="selectedImpact?.impactAnalysis" responsiveLayout="scroll">
                                        <ng-template pTemplate="body" let-product>
                                            <tr>
                                                <td>
                                                    <div style="text-align: center;">{{product.value}}</div>
                                                    <div><i class="light-color">&nbsp;</i></div>
                                                </td>
                                                <td>
                                                    <div class="tag1">
                                                        <span
                                                            [ngClass]="product?.type == 'positive' ? 'green-box' : 'red-box'">
                                                            <span class="p-mr-1"
                                                                *ngIf="product?.type == 'positive'">+</span>
                                                            {{product?.impact}}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="top-factor">
                        <div class="head2">
                            <h5 class="head1">Top Factors</h5>
                            <p class="head1">Individual factors ranked by their contribution to the prediction results
                            </p>
                        </div>
                        <p-card style="width: 100%;">
                            <p-table [value]="factors" dataKey="id" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 2rem"></th>
                                        <th>Factor</th>
                                        <th pTooltip="The percentage of records with this factor that have Account Type(s) of {{selectedCategory.name}}"
                                            tooltipPosition="top" style="text-align: center;">Rate of
                                            {{selectedCategory.name}}</th>
                                        <th pTooltip="The change in probability of when this factor is present"
                                            tooltipPosition="top" style="text-align: center;">Impact on
                                            {{selectedPredict?.header}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product>
                                    <tr>
                                        <td class="action">
                                            <button type="button" pButton pRipple [pRowToggler]="product"
                                                class="p-button-text p-button-rounded p-button-plain"></button>
                                        </td>
                                        <td>
                                            <span pTooltip="{{product.description}}" tooltipPosition="top"
                                                class="factor-name">{{product.name}}</span>
                                            <span pTooltip="{{product.description}}" tooltipPosition="top"
                                                class="p-mx-2">{{product.type}}</span>
                                            <span pTooltip="{{product.description}}" tooltipPosition="top"
                                                class="factor-name">{{product.value}}</span>
                                        </td>
                                        <td style="text-align: center;">{{product.percentage}}</td>
                                        <td style="text-align: center;">
                                            <span
                                                [ngClass]="product?.impact?.type == 'positive' ? 'green-box' : 'red-box'">
                                                <span class="p-mr-1"
                                                    *ngIf="product?.impact?.type == 'positive'">+</span>
                                                <span class="p-mr-1"
                                                    *ngIf="product?.impact?.type == 'negative'">-</span>
                                                {{product?.impact?.value}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-card>
                    </div>
                </div>

                <div *ngIf="predictionType == 'Regression'" class="p-grid">
                    <div class="p-col-6" style="font-size: 24px;" [class.p-pb-0]="isShowDetails">
                        <p-card [style]="{'width': '100%','height':'100%', 'padding': '10px'}"
                            [styleClass]="isShowDetails ? 'extend' : 'fixed-height'">
                            <p class="p-mb-0" style="color: #475467; font-size: 24px;">Model Score is usually within</p>
                            <h3 class="p-my-3" style="font-size: 24px;">
                                {{predictionResultCategory?.evaluation?.overallAccuracy}}</h3>
                                <div class="p-d-flex hoverable" 
                                style="color: hsl(218, 80.3%, 47.8%);"
                                (click)="isShowDetails = !isShowDetails">
                                <span [class.pi-angle-right]="!isShowDetails" 
                                      [class.pi-angle-down]="isShowDetails" 
                                      class="pi p-mr-1"></span>
                                {{ isShowDetails ? 'Hide accuracy details' : 'See accuracy details' }}
                           </div>
                           
                        </p-card>
                    </div>

                    <div class="p-col-6">
                        <p-card [style]="{'width': '100%'}" styleClass="no-padding custome-card">
                            <div class="p-d-flex" style="align-items: center;position: relative;">
                                <div style="width: 60%; height: 50%;" class="box1">
                                        <plotly-plot [data]="data5" [layout]="layout5"></plotly-plot>    
                                </div>
                                <div style="width: 40%;" class="box1">
                                    <label class="label-head">Average {{selectedPredict?.header}}</label>
                                    <h3>{{predictionPerformanceBlock?.Average}}</h3>
                                    <label class="label-head">Median {{selectedPredict?.header}}</label>
                                    <h3>{{predictionPerformanceBlock?.Median}}</h3>
                                </div>
                            </div>
                        </p-card>
                    </div>

                    <div class="p-col-12 p-pt-0" *ngIf="isShowDetails">
                        <p-card [style]="{'width': '100%'}" styleClass="no-top-radius">
                            <p class="desc1">{{predictionResultCategory?.evaluation?.description}}</p>
                            <h3>Predictive Performance</h3>
                            <div style="width: 100%;">
                                <plotly-plot [data]="data6" [layout]="layout6" ></plotly-plot>
                            </div>
                            <div class="card-container">
                                <div class="card-section">
                                    <div id="card1" class="card" [ngClass]="{'card-active': activeCard === 'accuracy'}"
                                        (click)="setActiveCard('accuracy')">
                                        <p class="label-head">Model Score is usually within</p>
                                        <p class="avg-num" style="color: #101828;">
                                            {{predictionResultCategory?.evaluation?.overallAccuracy}}</p>
                                    </div>
                                    <div id="card2" class="card" [ngClass]="{'card-active': activeCard === 'rmse'}"
                                        (click)="setActiveCard('rmse')">
                                        <p class="label-head">RMSE (Root Mean Square Error)</p>
                                        <p class="avg-num" style="color: #101828;">
                                            {{predictionResultCategory?.evaluation?.RMSE}}</p>
                                    </div>
                                    <div id="card3" class="card" [ngClass]="{'card-active': activeCard === 'mae'}"
                                        (click)="setActiveCard('mae')">
                                        <p class="label-head">MAE (Mean Absoulte Error)</p>
                                        <p class="avg-num" style="color: #101828;">
                                            {{predictionResultCategory?.evaluation?.MAE}}</p>
                                    </div>
                                </div>
                                <div class="card-section description-section">
                                    <p *ngIf="activeCard === 'accuracy'">
                                        {{predictionResultCategory?.evaluation?.accuracyDescription}}</p>
                                    <p *ngIf="activeCard === 'rmse'">
                                        {{predictionResultCategory?.evaluation?.rmseDescription}}</p>
                                    <p *ngIf="activeCard === 'mae'">
                                        {{predictionResultCategory?.evaluation?.maeDescription}}</p>
                                </div>
                            </div>
                        </p-card>
                    </div>

                    <div class="top-feilds">
                        <div class="head2">
                            <h5 class="head1">Top Fields</h5>
                            <p class="head1">Fields ranked by their contribution to the prediction results</p>
                        </div>
                        <div class="p-grid">
                            <div class="p-col-6 p-pr-0">
                                <ul class="field-menu">
                                    <li class="p-d-flex" *ngFor="let s of impact;let i=index"
                                        (click)="onSelctedImpact(s)" [class.isActive]="s?.name == selectedImpact?.name">
                                        <div class="p-text-right" style="width: 45%;"><span pTooltip="{{s.description}}"
                                                tooltipPosition="top">{{s?.name}}</span></div>
                                        <div class="p-d-flex w-100">
                                            <div pTooltip="{{s?.description}}" tooltipPosition="top"
                                                [ngStyle]="{'width': s?.value + '%'}" [className]="'block-bg-' + i">
                                            </div>
                                            <span pTooltip="{{s?.description}}"
                                                tooltipPosition="top">{{s?.value}}%</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="p-col-6 p-pl-0">
                                <div class="field-table">
                                    <div class="p-grid field-header">
                                        <div class="p-col-6" style="text-align: center;">
                                            When <strong>{{selectedImpact?.name}}</strong> is
                                        </div>
                                        <div class="p-col-6" style="text-align: center;">
                                            Impact on {{selectedPredict?.header}}
                                        </div>
                                    </div>
                                    <p-table [value]="selectedImpact?.impactAnalysis" responsiveLayout="scroll">
                                        <ng-template pTemplate="body" let-product>
                                            <tr>
                                                <td>
                                                    <div style="text-align: center;">{{product.value}}</div>
                                                    <div><i class="light-color">&nbsp;</i></div>
                                                </td>
                                                <td>
                                                    <div class="tag1"><span
                                                            [ngClass]="product?.type == 'positive' ? 'green-box' : 'red-box'">
                                                            <span class="p-mr-1"
                                                                *ngIf="product?.type == 'positive'">+</span>
                                                            <!-- <span class="p-mr-1" *ngIf="product.type == 'negative'">-</span> -->
                                                            {{product?.impact}}
                                                        </span></div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="top-factor">
                        <div class="head2">
                            <h5 class="head1">Top Factors</h5>
                            <p class="head1">Individual factors ranked by their contribution to the prediction results.
                            </p>
                        </div>
                        <p-card style="width: 100%;">
                            <p-table [value]="factors" dataKey="id" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 2rem"></th>
                                        <th>Factor</th>
                                        <th pTooltip="The average value of {{selectedPredict?.header}} among records with this factor"
                                            tooltipPosition="top" style="text-align: center;">Average value of
                                            {{selectedPredict?.header}}</th>
                                        <th pTooltip="The percentage of overall records with this factor"
                                            tooltipPosition="top" style="text-align: center;">Factor Frequency</th>
                                        <th pTooltip="The average change in the value {{selectedPredict?.header}} when this factor is present"
                                            tooltipPosition="top" style="text-align: center;">Impact on
                                            {{selectedPredict?.header}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product>
                                    <tr>
                                        <td class="action">
                                            <button type="button" pButton pRipple [pRowToggler]="product"
                                                class="p-button-text p-button-rounded p-button-plain"></button>
                                        </td>
                                        <td>
                                            <span pTooltip="{{product.description}}" tooltipPosition="top"
                                                class="factor-name">{{product.name}}</span>
                                            <span pTooltip="{{product.description}}" tooltipPosition="top"
                                                class="p-mx-2">{{product.type}}</span>
                                            <span pTooltip="{{product.description}}" tooltipPosition="top"
                                                class="factor-name">{{product.value}}</span>
                                        </td>
                                        <td style="text-align: center;">{{product.averageValue}}</td>
                                        <td style="text-align: center;">{{product.factorFrequency}}</td>
                                        <td style="text-align: center;">
                                            <span
                                                [ngClass]="product?.impact?.type == 'positive' ? 'green-box' : 'red-box'">
                                                <span class="p-mr-1"
                                                    *ngIf="product?.impact?.type == 'positive'">+</span>
                                                <span class="p-mr-1" *ngIf="product?.impact?.type == 'negative'"></span>
                                                {{product?.impact?.value}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-card>
                    </div>

                    <div class="segment1">
                        <div class="head2">
                            <h5 class="head1">Segments</h5>
                            <p class="head1">Sets of similar records in your dataset grouped by outcome of interest</p>
                        </div>
                        <div class="p-grid">
                            <div class="p-col-4" *ngFor="let segment of predictionSegmentBlock; let i = index">
                                <p-card styleClass="hover-box">
                                    <h5 class="p-d-flex p-mb-4">
                                        <div class="circle p-mr-2"[ngClass]="getSegmentColor(segment.segmentName)"></div>
                                        {{segment?.segmentName}}
                                    </h5>
                                    <h6 class="p-mb-2">{{segment?.segmentHeader}}</h6>
                                    <p>{{segment?.segmentDescription}}</p>
                                    <div class="p-text-center">
                                        <div style="margin: auto;width: 100%;">
                                            <plotly-plot [data]="segment.plotData" [layout]="segment.plotLayout"></plotly-plot>
                                        </div>
                                    </div>
                                    <div class="p-d-flex border-bottom p-p-3">
                                        <p style="flex-grow: 1;">Average value of {{selectedPredict?.header}}</p>
                                        <div class="p-text-right">
                                            <div style="font-size: 20px;" class="pointer">
                                                {{segment?.averageValue}}</div>
                                        </div>
                                    </div>
                                    <div class="p-d-flex p-p-3">
                                        <p style="flex-grow: 1;">Segment size</p>
                                        <div class="p-text-right">
                                            <div style="font-size: 20px;" class="pointer">{{segment?.segmentPercentage}}
                                            </div>
                                            <div style="font-size: 10px;">of all records</div>
                                        </div>
                                    </div>
                                </p-card>
                            </div>
                        </div>
                    </div>

                    <div class="sample-rows" style="width: 99%;">
                        <div class="head2">
                            <h5 class="head1">Sample Prediction</h5>
                            <p class="head1">
                                Sample rows of your data sorted by predicted value of the outcome of interest.
                                Drag the slider to inspect rows at different values.
                            </p>
                        </div>
                    
                        <!-- Use Flexbox for layout control -->
                        <div class="tables-container" style="display: flex; justify-content: space-between; gap: 20px;"> <!-- Added gap -->
                            <p-card style="width: 83%;"> <!-- Adjust width to control the size of the first table -->
                                <p-table 
                                    [value]="sampleRows" 
                                    [scrollable]="true" 
                                    [style]="{width:'100%'}" 
                                    [resizableColumns]="true"
                                    styleClass="p-datatable-sm"
                                    [autoLayout]="true"
                                    responsiveLayout="scroll"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th *ngFor="let col of sampleColumns" [pSortableColumn]="col">
                                                {{col}}
                                                <p-sortIcon [field]="col"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData>
                                        <tr>
                                            <td *ngFor="let col of sampleColumns">
                                                {{rowData[col]}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td [attr.colspan]="sampleColumns.length" class="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </p-card>
                    
                            <p-card class="w-80" style="width: 15%;"> <!-- Adjust width to control the size of the second table -->
                                <p-table 
                                    [value]="predictionRows" 
                                    [scrollable]="true"
                                    styleClass="p-datatable-sm"
                                    [autoLayout]="true"
                                    responsiveLayout="scroll"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>{{predictionResult?.category?.[0]?.prediction?.name}}
                                                <i class="pi pi-question-circle" 
                                                style="font-size: 1rem; cursor: help;"
                                                pTooltip="Predicted Result" 
                                                tooltipPosition="top">
                                             </i></th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData>
                                        <tr>
                                            <td>{{formatPredictionValue(rowData.value)}}</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td class="text-center">
                                                No predictions available
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </p-card>
                        </div>
                    
                        <div class="action-buttons">
                            <button pButton label="Predict on your Data" 
                                    icon="pi pi-plus" 
                                    class="p-button"
                                    (click)="showDialog = true">
                            </button>
                        </div>
                        <app-predict-dialog [(visible)]="showDialog" [savedSearchColumn]="columns" [targetColumn]="selectedPredict" [SavedSearchId]="selectedSearch?.id" [columnDefinitions]= "selectedWorkbookColumn" [columns]="sampleColumns" [workbookId]="selectedWorkbookId" (saveData)="addNewPredictionData($event)">
                        </app-predict-dialog>
                        <div class="mt-4">
                            <h5 class="head1">Your Prediction</h5>
                            <div class="tables-container" style="display: flex; justify-content: space-between; gap: 20px;">
                            <p-card style="width: 83%;">
                                <ng-container *ngIf="selectedWorkbookId">
                                    <p-table [value]="userInputRows" [scrollable]="true" [style]="{width:'100%'}" [resizableColumns]="true" styleClass="p-datatable-sm" [autoLayout]="true" responsiveLayout="scroll">
                                        <ng-template pTemplate="header">
                                            <tr>
                                              <th *ngFor="let col of selectedWorkbookColumn">
                                                <ng-container *ngIf="selectedPredict.name!=col.name" >
                                                    {{col?.name}}
                                                </ng-container>
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData>
                                            <tr>
                                              <td *ngFor="let col of selectedWorkbookColumn">
                                                <ng-container
                                                *ngIf="selectedPredict.name!=col.name">
                                                <ng-container [ngSwitch]="col?.formControlName">
                                                    <ng-container *ngSwitchCase="'DatePicker'">
                                                    {{ rowData?.[col.name] | localDate:'MM/DD/YYYY'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'DateTimePicker'">
                                                    {{ rowData?.[col.name] | localDate:'dateTime':false }}
                                                    </ng-container>
                                                    <!-- <ng-container *ngSwitchCase="'DropDownList'">
                                                    {{ rowData?.[col.name]?.label}}
                                                    </ng-container> -->
                                                    <ng-container *ngSwitchDefault>
                                                    {{rowData?.[col.name]}}
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                            <td [attr.colspan]="sampleColumns.length" class="text-center">
                                                No user-inputted data
                                            </td>
                                            </tr>
                                        </ng-template>
                                        </p-table>
                                </ng-container>
                                <ng-container *ngIf="selectedSearch?.id">
                                    <p-table [value]="userInputRows" [scrollable]="true" [style]="{width:'100%'}" [resizableColumns]="true" styleClass="p-datatable-sm" [autoLayout]="true" responsiveLayout="scroll">
                                        <ng-template pTemplate="header">
                                            <tr>
                                              <th *ngFor="let col of columns">
                                                <ng-container *ngIf="selectedPredict.header!=col.header" >
                                                    {{col?.header}}
                                                </ng-container>
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData>
                                            <tr>
                                              <td *ngFor="let col of columns">
                                                <ng-container
                                                *ngIf="selectedPredict.header!=col.header">
                                                <ng-container [ngSwitch]="col?.formControlType">
                                                    <ng-container *ngSwitchCase="'DatePicker'">
                                                    {{ rowData?.[col.header] | localDate:'MM/DD/YYYY'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'DateTimePicker'">
                                                    {{ rowData?.[col.header] | localDate:'dateTime':false }}
                                                    </ng-container>
                                                    <!-- <ng-container *ngSwitchCase="'DropDownList'">
                                                    {{ rowData?.[col.header]?.label}}
                                                    </ng-container> -->
                                                    <ng-container *ngSwitchDefault>
                                                    {{rowData?.[col.header]}}
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                            <td [attr.colspan]="sampleColumns.length" class="text-center">
                                                No user-inputted data
                                            </td>
                                            </tr>
                                        </ng-template>
                                        </p-table>
                                </ng-container>                 
                            </p-card>
                            <p-card class="w-80" style="width: 15%;">
                                <p-table [value]="userPredictionRows" [scrollable]="true" styleClass="p-datatable-sm" [autoLayout]="true" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                    <th>{{predictionResult?.category?.[0]?.prediction?.name}}
                                        <i class="pi pi-question-circle" style="font-size: 1rem; cursor: help;" pTooltip="Predicted Result" tooltipPosition="top">
                                        </i>
                                    </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData>
                                    <tr>
                                    <td>{{(rowData.prediction)}}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                    <td class="text-center">
                                        No prediction available
                                    </td>
                                    </tr>
                                </ng-template>
                                </p-table>
                            </p-card>
                            </div>
                        </div>
                    </div>
                    

                </div>

                <div *ngIf="forecastingType == 'Forecasting'">

                    <p-card>
                        <div class="p-d-flex">
                            <div class="border-right p-pl-3 p-pr-5">
                                <p class="p-mb-0" style="color: #888;">Forecast Column</p>
                                <h5 class="p-mb-0" style="position: relative;">{{selectedPredict?.header || selectedPredict?.name}}
                                </h5>
                            </div>
                            <div class="deck1" style="margin-left: auto;"><button class="btn1" (click)="changePredict()">Re-Train
                                    Model</button></div>
                        </div>
                    </p-card>

                    <div class="head2">
                        <h5 class="head1" style="margin-top: 10px;">{{forecastResult.title}}</h5>
                        <p class="head1" style="color: #888;">{{forecastResult.description}}</p>
                    </div>

                    <div style="display: flex; align-items: stretch;">
                        <div class="p-col-6" [class.p-pb-0]="isShowDetails" style="flex: 1;">
                            <p-card
                            class="forecast-card"
                                [styleClass]="isShowDetails ? 'extend' : 'fixed-height'">
                                <div class="forecast-content">
                                    <p class="forecast-title">Model Score</p>
                                    <h3 class="forecast-score" pTooltip="{{forecastingResultCategory?.firstBlock?.accuracyDescription}}" tooltipPosition="top">
                                        {{forecastingResultCategory?.firstBlock?.accuracy}}</h3>
                                    <p class="forecast-description">{{forecastingResultCategory?.firstBlock?.description}}</p>
                                </div>
                                <div class="forecast-toggle hoverable"
                                    (click)="isShowDetails = !isShowDetails">
                                    <span [class.pi-angle-right]="!isShowDetails" [class.pi-angle-down]="isShowDetails" class="pi p-mr-1"></span>
                                    {{ isShowDetails ? 'Hide accuracy details' : 'See accuracy details' }}
                                </div>
                            </p-card>
                        </div>
                    
                        <div class="p-col-6" style="flex: 1;">
                            <p-card class="forecast-chart-card" styleClass="no-padding custome-card">
                                <div class="forecast-chart-container">
                                    <div class="forecast-chart">
                                            <plotly-plot [data]="data1" [layout]="layout1" class="plotly-chart"></plotly-plot>
                                    </div>
                                    <div class="forecast-stats">
                                        <label class="label-head" pTooltip="{{secondForecasting?.mean_distribution}}" tooltipPosition="top">Mean {{selectedPredict?.header}}</label>
                                        <h3 pTooltip="{{secondForecasting?.mean_distribution}}" tooltipPosition="top">{{secondForecasting?.mean}}</h3>
                                        <label class="label-head">Median {{selectedPredict?.header}}</label>
                                        <h3 pTooltip="{{secondForecasting?.median_distribution}}" tooltipPosition="top">{{secondForecasting?.median}}</h3>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>
                    
                    
                    <div class="p-col-12 p-pt-0" *ngIf="isShowDetails">
                        <p-card [style]="{'width': '100%'}" styleClass="no-top-radius">
                            <h3>Forecastive Performance</h3>
                            <div class="card-container1">
                                <div class="card-section1" style="height: 100%;">
                                        <plotly-plot [data]="data" [layout]="layout"></plotly-plot>
                                </div>
                                <div class="card-section1">
                                    <div id="card1" class="card1" [ngClass]="{'card-active': activeCard === 'accuracy'}"
                                        (click)="setActiveCard('accuracy')">
                                        <p class="label-head">Model Score is usually within</p>
                                        <p class="avg-num" style="color: #101828;">
                                            {{forecastingResultCategory?.firstBlock?.accuracy}}</p>
                                    </div>
                                    <div id="card2" class="card1" [ngClass]="{'card-active': activeCard === 'rmse'}"
                                        (click)="setActiveCard('rmse')">
                                        <p class="label-head">RMSE (Root Mean Square Error)</p>
                                        <p class="avg-num" style="color: #101828;">
                                            {{forecastingResultCategory?.firstBlock?.mse}}</p>
                                    </div>
                                    <div id="card3" class="card1" [ngClass]="{'card-active': activeCard === 'mae'}"
                                        (click)="setActiveCard('mae')">
                                        <p class="label-head">MAE (Mean Absoulte Error)</p>
                                        <p class="avg-num" style="color: #101828;">
                                            {{forecastingResultCategory?.firstBlock?.mae}}</p>
                                    </div>
                                </div>
                                <div class="card-section1 description-section">
                                    <ng-container *ngIf="activeCard === 'accuracy'">
                                        <p *ngFor="let line of getFormattedDescription(forecastingResultCategory?.firstBlock?.accuracyDescription)">
                                            {{ line }}
                                        </p>
                                    </ng-container>
                                    <ng-container *ngIf="activeCard === 'rmse'">
                                        <p *ngFor="let line of getFormattedDescription(forecastingResultCategory?.firstBlock?.rmseDescription)">
                                            {{ line }}
                                        </p>
                                    </ng-container>
                                    <ng-container *ngIf="activeCard === 'mae'">
                                        <p *ngFor="let line of getFormattedDescription(forecastingResultCategory?.firstBlock?.maeDescription)">
                                            {{ line }}
                                        </p>
                                    </ng-container>
                                </div>
                                
                            </div>
                        </p-card>
                    </div>

                    <div class="p-col-12 p-pt-0">
                        <div class="dev1">
                            <h3>Forecast</h3>
                            <p class="dev2">The predictions of the model, compared to the historical data and extrapolated forward.</p>
                        </div>
                        <p-card [style]="{'width': '100%'}" styleClass="no-top-radius">
                                <plotly-plot [data]="data2" [layout]="layout2"></plotly-plot>
                                <div class="p-d-flex hoverable" style="color: hsl(218, 80.3%, 47.8%); cursor: pointer; padding: 10px;"
                                    (click)="isShowTable = !isShowTable">
                                    <span [class.pi-angle-right]="!isShowTable" [class.pi-angle-down]="isShowTable" class="pi p-mr-1"></span>
                                    {{ isShowTable ? 'Hide Table' : 'Show Table' }}
                                </div>
                        </p-card>
                    </div>

                    <div class="p-col-12 p-pt-0" *ngIf="isShowTable">
                        <p-card [style]="{'width': '100%'}" styleClass="no-top-radius">
                            <div class="forecast-table-container">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Forecasted {{forecastResult?.targetColumn}}</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div class="table-scroll">
                                    <table>
                                        <tbody>
                                            <tr *ngFor="let item of futureArray">
                                                <td class="center">{{ item.date | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
                                                <td class="center">{{ item.value }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </p-card>
                    </div>

                    <div class="seasonality">
                        <div class="dev3">
                          <h3>Seasonality</h3>
                          <p class="dev4">Variations that occur at specific regular intervals</p>
                        </div>
                        <div class="p-grid">
                          <div class="p-col-6 p-pr-0">
                            <ul class="field-menu">
                                <li class="p-d-flex"
                                    (click)="selectedSeasonality = 'quarterly'"
                                    [class.isActive]="selectedSeasonality === 'quarterly'">
                                  <div class="p-text-center" style="width: 100%; text-align: center;">
                                    Quarterly
                                  </div>
                                </li>
                                <li class="p-d-flex"
                                    (click)="selectedSeasonality = 'monthly'"
                                    [class.isActive]="selectedSeasonality === 'monthly'">
                                  <div class="p-text-center" style="width: 100%; text-align: center;">
                                    Monthly
                                  </div>
                                </li>
                            </ul>
                          </div>
                          <div class="p-col-6 p-pl-0">
                            <div class="field-table" style="text-align: center;">
                              <plotly-plot *ngIf="selectedSeasonality === 'monthly'" [data]="data3" [layout]="layout3"></plotly-plot>
                              <plotly-plot *ngIf="selectedSeasonality === 'quarterly'" [data]="data4" [layout]="layout4"></plotly-plot>
                            </div>
                          </div>
                        </div>
                      </div>
                                         
                </div>

                <p-dialog header="Image Preview" [(visible)]="displayModal" [modal]="true" [style]="{width: '40vw'}" *ngIf="predictionType === 'Regression' || predictionType === 'Classification'">
                    <img [src]="selectedImage" style="width: 100%; height: auto;" />
                    <h3 style="margin-top: 20px;">Description:</h3>
                    <ul style="list-style-type: none; padding-left: 0;">
                        <li *ngFor="let line of chartDescription" style="margin-bottom: 10px; white-space: pre-line;">{{chartDescription}}</li>
                    </ul>
                </p-dialog>
                <p-dialog header="Image Preview" [(visible)]="displayModal" [modal]="true" [style]="{width: '75vw'}" *ngIf="forecastingType == 'Forecasting'">
                    <img [src]="selectedImage" style="width: 100%; height: auto;" />
                    <ul style="list-style-type: none; padding-left: 0;">
                        <li *ngFor="let line of chartDescription" style="margin-bottom: 10px; white-space: pre-line;">{{line}}</li>
                    </ul>
                </p-dialog>
            </div>
        </div>
    </div>
</p-dialog>